var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 31,
    rx: 5.5,
    stroke: "#DFE3E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4822 9C35.7984 9 36.8628 9.30277 37.5338 9.57698L37.0711 12.5034L36.7634 12.3595C36.1478 12.0855 35.3351 11.8117 34.229 11.8406C32.8857 11.8406 32.2833 12.4314 32.2694 13.0082C32.2694 13.6427 32.9981 14.0608 34.1881 14.6809C36.1483 15.6468 37.0575 16.829 37.044 18.3717C37.0164 21.1832 34.6923 23 31.1224 23C29.596 22.9854 28.1258 22.6532 27.3279 22.2787L27.804 19.2365L28.252 19.4531C29.358 19.9582 30.0859 20.1739 31.4442 20.1739C32.4238 20.1739 33.474 19.7554 33.4874 18.8475C33.4874 18.2564 33.04 17.8235 31.7237 17.1603C30.4358 16.5113 28.7139 15.4301 28.7418 13.4836C28.7564 10.8453 31.1224 9 34.4822 9Z",
    fill: "#00579F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7979 22.798H25.2002L27.3281 9.24567H23.9259L21.7979 22.798Z",
    fill: "#00579F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2554 9.24567H43.6238C42.8122 9.24567 42.1956 9.49056 41.8455 10.3701L36.7918 22.7978H40.3617C40.3617 22.7978 40.9495 21.1252 41.0758 20.7649H45.4441C45.5417 21.2407 45.85 22.7978 45.85 22.7978H49.0002L46.2554 9.24567ZM42.0557 17.9969C42.3359 17.2183 43.4141 14.2051 43.4141 14.2051C43.4084 14.2168 43.4529 14.0896 43.5191 13.9007C43.6167 13.6219 43.7616 13.2083 43.8617 12.9076L44.0995 14.0753C44.0995 14.0753 44.7438 17.3193 44.8837 17.9969H42.0557Z",
    fill: "#00579F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6242 18.4871L18.9561 9.24567H22.5538L17.206 22.7837H13.6081L10.5562 10.9321C12.7121 12.1005 14.644 14.4502 15.2601 16.6128L15.6242 18.4871Z",
    fill: "#00579F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.53 9.24566H7.056L7 9.51949C11.27 10.6441 14.098 13.355 15.2599 16.6134L14.0699 10.3849C13.874 9.5193 13.2719 9.27421 12.53 9.24566Z",
    fill: "#FAA61A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.961f97c43a8db993c985e73bf69660eb.svg";
export { ForwardRef as ReactComponent };